import script from "./TaskEventScheduler.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskEventScheduler.vue?vue&type=script&setup=true&lang=js"

import "./TaskEventScheduler.vue?vue&type=style&index=0&id=f66e966a&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f66e966a"]])

export default __exports__